/**
 * SitePick front — 商品詳細の dataLayer（docs/10 §6.3 `view_item`）
 *
 * `/sites/{slug}/` の `<main data-sp-page="detail" data-sp-item='{json}'>` を唯一の
 * 元データにする（価格の二重管理をしない）。詳細ページに 1 回だけ push。
 * `/live/` は詳細ではないので `data-sp-page` を持たせない側で除外する。
 */

import { push, readItem } from "./analytics.js";

/**
 * 詳細ページで `view_item` を 1 回 push。
 *
 * @returns {void}
 */
export function initDetailTracking() {
  const holder = document.querySelector("[data-sp-page=\"detail\"][data-sp-item]");
  if (!holder) {
    return;
  }
  const item = readItem(holder);
  if (!item) {
    return;
  }
  // bfcache / 戻る対策: このページ URL で 1 回だけ。
  const guardKey = `sp_vitem_${window.location.pathname}`;
  try {
    if (window.sessionStorage.getItem(guardKey)) {
      return;
    }
    window.sessionStorage.setItem(guardKey, "1");
  } catch {
    /* private mode 等。ガードなしで続行 */
  }
  push("view_item", {
    currency: item.currency || "JPY",
    value: typeof item.price === "number" ? item.price : 0,
    items: [item],
  });
}
